var $fbf486af29f0df75$exports = {};
$fbf486af29f0df75$exports = {
    "collapse": `Sutraukti`,
    "expand": `I\u{161}skleisti`
};


export {$fbf486af29f0df75$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
